module.exports = __webpack_public_path__ + "media/banner.852d5540.mp4";